import React from "react";
import { AuthProvider } from "./AuthContext";
// import other providers if needed

export const AppContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <AuthProvider>
      {/* add more nested providers here */}
      {children}
    </AuthProvider>
  );
};
